import { Message } from "primereact/message";
import { getIn } from "formik";
const ErrorMessage = ({ id, formik }: { id: string; formik: any }) => {
  return (
    (formik.submitCount > 0 || getIn(formik.touched, id)) &&
    getIn(formik.errors, id) && <Message severity="error" text={getIn(formik.errors, id)} className="w-full" />
  );
};

export default ErrorMessage;
